type Falsy = null | undefined | false | 0 | typeof NaN;
type ClassName = string | Falsy;

export const classNames = (...names: ClassName[]): string | undefined =>
  names.filter(Boolean).join(' ');
